import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStudentPaperAssignments,
  downloadOriginalAssignment,
  clearError,
} from "../paperAssignmentSlice";
import { fetchAssignmentList } from "../../assignment/assignmentSlice";
import StudentPaperAssignmentCalendar from "./StudentPaperAssignmentCalendar";
import LevelTestSummary from "../../leveltest/components/LevelTestSummary";
import { CONTAINER_MAX_WIDTH } from "../../../styles/layout";

const PaperAssignmentTable = () => {
  const dispatch = useDispatch();
  const { student } = useSelector((state) => state.student);
  const { mode } = useSelector((state) => state.ui);
  const isMobile = mode === "mobile";
  const { assignments, error } = useSelector(
    (state) => state.paperAssignment
  );
  const [finishedAssignments, setFinishedAssignments] = React.useState([]);

  useEffect(() => {
    if (student?.id) {
      dispatch(fetchStudentPaperAssignments(student.id));

      dispatch(fetchAssignmentList({ studentId: student.id, isFinished: true, page: 1, limit: 1000 }))
        .then((result) => {
          if (result.payload?.results) {
            setFinishedAssignments(result.payload.results);
          }
        });
    }
  }, [dispatch, student]);

  useEffect(() => {
    if (error) {
      alert(`오류: ${error.error || error}`);
      dispatch(clearError());
    }
  }, [error, dispatch]);

  const handleOriginalAssignmentDownload = async (s3Key) => {
    if (!student?.id) {
      alert("학생 정보를 찾을 수 없습니다. 다시 로그인 해주세요.");
      return;
    }

    try {
      const result = await dispatch(
        downloadOriginalAssignment({
          studentId: student.id,
          s3Key,
        })
      );

      if (downloadOriginalAssignment.fulfilled.match(result)) {
        const { download_url } = result.payload;
        window.open(download_url, "_blank");
      }
    } catch (downloadError) {
      console.error("Download error:", downloadError);
      alert("원본 과제 다운로드 중 오류가 발생했습니다.");
    }
  };

  return (
    <div
      style={{
        maxWidth: `${CONTAINER_MAX_WIDTH}px`,
        margin: "0 auto",
        padding: isMobile ? "16px 12px 40px" : "26px 22px 60px",
      }}
    >
      {/* 히어로 */}
      <div style={{ marginBottom: isMobile ? "16px" : "22px" }}>
        <h2
          style={{
            fontSize: isMobile ? "1.15rem" : "1.5rem",
            fontWeight: 800,
            color: "#0E141B",
            lineHeight: 1.4,
            margin: 0,
            wordBreak: "keep-all",
          }}
        >
          {student?.name ? `${student.name} 학생, ` : ""}오늘 배운 그 내용
          <br />
          <span style={{ boxShadow: "inset 0 -12px 0 rgba(0,217,192,.35)", padding: "0 .06em" }}>
            집에서 한 번 더
          </span>{" "}
          완성해요
        </h2>
        <p style={{ color: "#7A8490", fontSize: isMobile ? "0.84rem" : "0.92rem", marginTop: "6px" }}>
          날짜를 누르면 그날의 알림장과 과제를 한눈에 볼 수 있어요.
        </p>
      </div>

      {/* 레벨테스트는 ECHO 쪽 기록이라 과제 계통과 별개다. 학생이 자기 링크 안에서
          이번 달 점수를 바로 보게 캘린더 위에 얹는다. */}
      <LevelTestSummary />

      <StudentPaperAssignmentCalendar
        assignments={assignments}
        onlineAssignments={finishedAssignments || []}
        onDownloadHomework={handleOriginalAssignmentDownload}
      />
    </div>
  );
};

export default PaperAssignmentTable;
